module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', [_c('i', [_vm._v("I give glory to God")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "fn2"
  }, [_c('span', [_c('i', [_vm._v("I give thanks for love")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "fn2"
  }, [_c('span', [_c('i', [_vm._v("I am deeply grateful for the patience and support of")])])]), _vm._v(" "), _c('p', {
    staticClass: "fn2"
  }, [_c('span', [_c('i', [_vm._v("my friend and agent, Aaron Priest")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "fn2"
  }, [_c('span', [_c('i', [_vm._v("Thanks to Marc Resnick, my wonderful editor")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "fn2"
  }, [_c('span', [_c('i', [_vm._v("and the other good folks at St. Martin’s Press")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "fn2"
  }, [_c('span', [_c('i', [_vm._v("And blessings and peace be upon you, dear reader")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "fn2"
  }, [_c('span', [_c('i', [_vm._v("and on us all")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3694532a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 72
// module chunks = 0